import React, { useState, useEffect } from 'react';
import { DateRangePicker } from 'react-dates';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';

const DateRangePickerComponent = ({ item, onChange }) => {
	const [fromDate, setFromDate] = useState(item.value1 ? moment(item.value1, 'YYYY-MM-DD') : null);
	const [toDate, setToDate] = useState(item.value2 ? moment(item.value2, 'YYYY-MM-DD') : null);
	const [focusedInput, setFocusedInput] = useState(null);
	const [manualStartDate, setManualStartDate] = useState('');
	const [manualEndDate, setManualEndDate] = useState('');
	const [visibleMonth, setVisibleMonth] = useState(() => {
		if (item.value1) return moment(item.value1, 'YYYY-MM-DD');
		if (item.value2) return moment(item.value2, 'YYYY-MM-DD');
		return moment();
	});

	// Sync with prop changes
	useEffect(() => {
		setFromDate(item.value1 ? moment(item.value1, 'YYYY-MM-DD') : null);
		setToDate(item.value2 ? moment(item.value2, 'YYYY-MM-DD') : null);
	}, [item.value1, item.value2]);

	useEffect(() => {
		const from = fromDate ? fromDate.format('YYYY-MM-DD') : '';
		const to = toDate ? toDate.format('YYYY-MM-DD') : '';
		setManualStartDate(from);
		setManualEndDate(to);
	}, [fromDate, toDate]);

	const saveDate = (startDate, endDate) => {
		setFromDate(startDate);
		setToDate(endDate);

		if (startDate && endDate) {
			let from = startDate.format('YYYY-MM-DD');
			let to = endDate.format('YYYY-MM-DD');
			onChange(item.valName, item.type, item.paramName1, item.paramName2, from, to);
		}
	};

	const handlePrevMonthClick = () => {
		setVisibleMonth((prev) => prev.clone().subtract(1, 'month'));
	};

	const handleNextMonthClick = () => {
		setVisibleMonth((prev) => prev.clone().add(1, 'month'));
	};

	const applyManualDateRange = () => {
		const trimmedStartValue = manualStartDate.trim();
		const trimmedEndValue = manualEndDate.trim();

		if (!trimmedStartValue || !trimmedEndValue) {
			return;
		}

		const startDate = moment(trimmedStartValue, 'YYYY-MM-DD', true);
		const endDate = moment(trimmedEndValue, 'YYYY-MM-DD', true);

		if (!startDate.isValid() || !endDate.isValid()) {
			return;
		}

		saveDate(startDate, endDate);
		setVisibleMonth(startDate.clone());
	};

	return (
		<div className="card date-range-card">
			<div
				className="manual-date-range-input-wrap"
				style={{
					padding: '8px 8px 0 8px',
					backgroundColor: '#000',
					display: 'flex',
					gap: '8px'
				}}
			>
				<input
					type="search"
					className="form-control manual-date-range-input mb-2"
					placeholder="Start Date (YYYY-MM-DD)"
					value={manualStartDate}
					onChange={(e) => setManualStartDate(e.target.value)}
					onBlur={applyManualDateRange}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							applyManualDateRange();
						}
					}}
					style={{
						display: 'block',
						visibility: 'visible',
						opacity: 1,
						width: '50%',
						position: 'relative',
						zIndex: 2,
						backgroundColor: '#fff'
					}}
				/>
				<input
					type="search"
					className="form-control manual-date-range-input mb-2"
					placeholder="End Date (YYYY-MM-DD)"
					value={manualEndDate}
					onChange={(e) => setManualEndDate(e.target.value)}
					onBlur={applyManualDateRange}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							applyManualDateRange();
						}
					}}
					style={{
						display: 'block',
						visibility: 'visible',
						opacity: 1,
						width: '50%',
						position: 'relative',
						zIndex: 2,
						backgroundColor: '#fff'
					}}
				/>
			</div>
			<div className="card-header" id={`${item.valName}_header`}>
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target={`#${item.valName}`}
						aria-expanded="false"
						aria-controls={`${item.valName}_header`}
					>
						{item.title}
						dfdfdfd
					</button>
				</h5>
			</div>
			<div id={item.valName} className="collapse" aria-labelledby={`${item.valName}_header`}>
				<div className="card-body">
					<div className="pt-3 search-filter">
						<DateRangePicker
							key={`${item.valName}-date-picker`}
							daySize={25}
							numberOfMonths={1}
							minimumNights={0}
							displayFormat="MMM DD"
							isOutsideRange={() => false}
							startDate={fromDate}
							startDateId={`${item.valName}_start_date`}
							endDate={toDate}
							endDateId={`${item.valName}_end_date`}
							onDatesChange={({ startDate, endDate }) => saveDate(startDate, endDate)}
							focusedInput={focusedInput}
							onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
							keepOpenOnDateSelect={true}
							reopenPickerOnClearDates={false}
							hideKeyboardShortcutsPanel={true}
							initialVisibleMonth={() => visibleMonth}
							onPrevMonthClick={handlePrevMonthClick}
							onNextMonthClick={handleNextMonthClick}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (store) => {
	return {
		selectedFilterItems: store.filters.selectedFilterItems
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DateRangePickerComponent);
